<template>
  <div class="initiate-action-table-cell">
    <div class='initiate-action-section' @click='initiateAction'>
      <span class="material-icons">
        build
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectProviderTableCell',
  item: {
    type: Object,
    required: true,
  },
  column: {
    type: Object,
    required: true,
  },
  methods: {
    initiateAction() {
      // initiate action
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";
.initiate-action-table-cell {
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  margin-left: -2%;
  display: var(--displayactioncell);
  .initiate-action-section {
    z-index: 3;
    align-items: center;
    display: flex;
    justify-content: center;
    min-width: rem(32);
    min-height: rem(32);
    background-color: var(--bg-secondary);
    border-radius: $radius-md;
    box-shadow: 0 0 rem(1) 0 rgba(0,0,0,0.14), 0 0 rem(1) 0 rgba(0,0,0,0.14);
    .material-icons {
      transform: scaleX(-1);
      color: var(--text-secondary);
      font-size: rem(18);
      user-select: none;
    }
    &:hover {
      cursor: pointer;
      border: 1px solid var(--brand-primary);
      background-color: var(--bg-tertiary) !important;
    }
    &:active{
      border: 1px solid var(--brand-primary);
      background-color: var(--bg-tertiary) !important;
    }
  }
}

.name {
  font-size: rem(14);
  line-height: rem(20);
  display: inline-block;
}

img.avatar {
  width: rem(24);
  height: rem(24);
  display: inline-block;
}

::v-deep .v-avatar {
  min-width: rem(24) !important;
  width: rem(24) !important;
  min-height: rem(24) !important;
  height: rem(24) !important;
  margin: rem(8) rem(8) rem(8) 0;
}

.initials {
  background-color: rgba(14, 31, 51, 0.15);
  border-radius: rem(50);
  color: var(--brand-primary);
  height: rem(24);
  width: rem(24);
  font-size: rem(14);
  font-family: $font-family-regular;
}
</style>
